export const API_HOST = process.env.REACT_APP_API_HOST;
export const okayNWAAIToken = process.env.REACT_APP_OKAYNWA_AI_ACTION_TOKEN;
export const okayNWAAIActionHost = process.env.REACT_APP_OKAYNWA_AI_ACTION_HOST;

export const REACT_APP_AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
export const REACT_APP_AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;